import { IconFunctionalClock16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { FloatingLabel } from 'shared/components/FloatingLabel';
import { NBSP } from 'shared/constants';
import { selectIsEarlyAccessLabelEnabled } from 'shared/selectors/selectIsEarlyAccessLabelEnabled';

export const EarlyAccessLabelContainer = () => {
  const isEarlyAccessLabelEnabled = useSelector(selectIsEarlyAccessLabelEnabled);

  if (!isEarlyAccessLabelEnabled) {
    return null;
  }

  return (
    <FloatingLabel
      data-testid="EarlyAccessLabel"
      labelText="Ранний доступ"
      tooltipText={`Новые объявления от собственников,\nопубликованные в${NBSP}течение последних нескольких\nчасов. Просмотр контактов — платный`}
      color="decorative-purple"
      backgroundColor="decorative-lavender-transparent"
      icon={<IconFunctionalClock16 color="decorative-purple" />}
    />
  );
};
